var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("slide-show", { attrs: { id: _vm.id } }, [
    _vm.premiseTypes && _vm.premiseTypes.length > 0
      ? _c(
          "div",
          { staticClass: "slider__label" },
          [
            _vm._l(_vm.premiseTypes, function (p, idx) {
              return [
                _c(
                  "span",
                  { key: `premise-${idx}`, staticClass: "slider__label-item" },
                  [
                    p.icon
                      ? _c("i", {
                          class: `fa-regular fa-${p.icon} slider__label-icon`,
                          attrs: { "aria-hidden": "true" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    p.type
                      ? _c("span", { staticClass: "slider__label-text" }, [
                          _vm._v(_vm._s(p.type)),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                idx < _vm.premiseTypes.length - 1
                  ? _c(
                      "span",
                      {
                        key: `separator-${idx}`,
                        staticClass: "slider__label-separator",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("\n        |\n      ")]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        )
      : _vm.iconLabel
      ? _c("div", { staticClass: "slider__label" }, [
          _c("i", {
            staticClass: "fa-regular fa-briefcase-blank slider__label-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "slider__label-text" }, [
            _vm._v(_vm._s(_vm.iconLabel)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "slider" },
      _vm._l(_vm.galleryImages, function (image, index) {
        return _c(
          "div",
          { key: `slide-${index}`, staticClass: "slider__item" },
          [
            _c("img", {
              attrs: {
                src: _vm.getNormalizedSrc(image),
                alt: _vm.getNormalizedAlt(image),
                loading: index === 0 ? "eager" : "lazy",
              },
            }),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.showNavigation && _vm.hasMultipleImages
      ? _c(
          "div",
          {
            staticClass: "slider__nav",
            attrs: { "aria-label": `${_vm.title} navigation` },
          },
          _vm._l(_vm.galleryImages, function (image, index) {
            return _c("button", {
              key: `nav-${index}`,
              staticClass: "slider__nav__button",
              attrs: {
                "aria-label": `Go to slide ${index + 1}`,
                type: "button",
              },
            })
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }